import { useState } from 'react';
import { findVerse } from '@rb/shared/admin-verses';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useActiveVerseStore } from '@/verse/active-verse.store';
import { ActionBar } from './ActionBar';
import { EnvSelector, envSchemaForVerseEnv, type EnvSchema } from './EnvSelector';
import { SupabaseLoginGate } from './SupabaseLoginGate';
import { TableEditor } from './TableEditor';
import { TableSidebar, type TableName } from './TableSidebar';

export function MasterDataPage() {
  const activeVerseId = useActiveVerseStore((s) => s.activeVerseId);
  const activeVerse = activeVerseId ? findVerse(activeVerseId) : null;
  const defaultEnv: EnvSchema = activeVerse ? envSchemaForVerseEnv(activeVerse.env) : 'dev';
  const [env, setEnv] = useState<EnvSchema>(defaultEnv);
  const [table, setTable] = useState<TableName>('world');

  return (
    <SupabaseLoginGate>
      <div
        className="grid h-[calc(100vh-32px)] bg-background text-foreground"
        style={{ gridTemplateColumns: '240px 1fr' }}
      >
        <aside className="overflow-y-auto border-r border-border p-3">
          <EnvSelector value={env} onChange={setEnv} />
          <TableSidebar value={table} onChange={setTable} />
        </aside>
        <main className="overflow-auto p-3">
          <ActionBar env={env} />
          <ErrorBoundary key={`${env}:${table}`}>
            <TableEditor env={env} table={table} />
          </ErrorBoundary>
        </main>
      </div>
    </SupabaseLoginGate>
  );
}

export default MasterDataPage;
